<template>
  <div class="layout" ref="layout" :style="homeStyle">
    <div class="layout_body" ref="layout_body">
      <div class="layout_body_aside_molile" v-if="isMobile">
        <layot-aside-mobile :navList="navList"/>
      </div>
      <div class="layout_body_aside" :class="{ bg: navType === '01' && isShowSide  }" v-else>
        <layot-aside
          v-show="isShowSide"
          ref="layout_side"
          :style="{ transform: `translateY(${translate}px)` }"
          class="layout_body_aside_panel"
          :viewType="navType"
          :navList="navList"
        />
      </div>
      <div class="layout_body_container" :style="{ paddingLeft: bodyLeftPad }">
        <router-view />
      </div>
    </div>
    <layot-footer :navList="navList" ref="footer" />
  </div>
</template>

<script>
import Aside from "./Aside.vue";
import AsideMobile from "./AsideMobile.vue";
import { getWindowSize, debounce } from "@/utils/index";
import { insertCallback, removeCallback } from "@/utils/windowResize";
import { addListener, removeListener } from "./../utils/listener";
import PcFooter from "@/components/Footer/Index.vue";
import { getPageHeight } from "@/utils/autoSize.js";
import { getNavList } from "@/api";

export default {
  name: "LayOut",
  components: {
    LayotAside: Aside,
    LayotFooter: PcFooter,
    LayotAsideMobile: AsideMobile
  },
  data() {
    return {
      isShowSide: true,
      useFix: true,
      translate: 0,
      show: false,
      count: 0,
      isMobile: false,
      scrollTop: 0,
      sideHeight: "auto",
      pageScrollTop: 0,
      scrollCb(){},
      navList: null
    };
  },
  computed: {
    homeStyle() {
      return this.$route.name === "ArrNoRepeat"
        ? {}
        : this.isMobile
        ? { backgroundPosition: "0px 250px" }
        : { backgroundPosition: "0px -1200px" };
    },
    bodyLeftPad() {
      return this.$route.name === "ArrNoRepeat"
        ? "0px"
        : this.isMobile
        ? "0px"
        : "2.5rem";
    },
    navType() {
      if (this.$route.name === "ArrNoRepeat") {
        const st = this.pageScrollTop;
        if (st < getPageHeight() / 3) {
          return "01";
        } else {
          return "02";
        }
      } else {
        return "02";
      }
      // return this.$route.name === "ArrNoRepeat" ? "01" : "02";
    },
    
  },
  created() {
    this.judgeIsMobile();
    addListener("side_update", "side_update01", this.updateSideBar.bind(this));
    addListener(
      "side_check_InView",
      "ide_check_InView_01",
      this.checkIfInView.bind(this)
    );
    this.scrollCb = debounce(this.updateScrollTop, 50).bind(this);
    window.addEventListener("scroll", this.scrollCb);
  },
  mounted() {
    // this.checkIfInView = debounce(this.checkIfInView, 50).bind(this);
    this.checkIfInView = this.checkIfInView.bind(this);
    // this.handelResize = debounce(this.handelResize, 50).bind(this)
    window.addEventListener("scroll", this.checkIfInView);
    insertCallback("layout_01", this.handelResize);
    this.updateSideBar();
    this.handleGetNavList();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.checkIfInView);
    removeCallback("layout_01");
    removeListener("side_update", "side_update01");
    removeListener("side_check_InView", "ide_check_InView_01");
    window.removeEventListener("scroll", this.scrollCb);
  },
  provide: {
    // updateSideBar: this.updateSideBar.bind(this)
  },
  methods: {
    handleGetNavList() {
      getNavList().then(res => {
        this.navList = res.data.data;
      });
    },
    updateScrollTop(){
      this.pageScrollTop = window.document.documentElement.scrollTop
    },
    updateSideBar() {
      const sideEl = (this.$refs.layout_side || {}).$el;
      this.sideHeight = sideEl
        ? `${sideEl.getBoundingClientRect().height}px`
        : "auto";
    },
    judgeIsMobile() {
      this.isMobile = getWindowSize() <= 640;
    },
    checkIfInView() {
      const target = (this.$refs.footer || {}).$el;
      const layout = this.$refs.layout;
      const layout_side = (this.$refs.layout_side || {}).$el;
      const layout_body = this.$refs.layout_body;
      if (!target || !layout || !layout_side || !layout_body) {
        return;
      }
      let pageHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const pageWidth =
        window.innerWidth || document.documentElement.clientWidth;
      if (pageWidth <= 640) {
        return;
      }
      // 获取目标元素的边界信息
      const sideRec = layout_side.getBoundingClientRect();
      const rect = target.getBoundingClientRect();
      const layoutRect = layout.getBoundingClientRect();
      const layoutContainer = layout_body.getBoundingClientRect();
      const isInView = rect.top <= pageHeight;
      const lastscrollTop = this.scrollTop;

      const maxInnerHeight = layoutContainer.height;
      if (maxInnerHeight < pageHeight) {
        //1.内容与footer在同屏内, 绝对定位显示
        this.useFix = false;
        this.isShowSide = true;
      } else {
        this.useFix = true;
        this.isShowSide = !isInView;
        if (!this.isShowSide) {
          return;
        }
        //2.内容与footer不在同屏内
        let translate = 0;
        if (sideRec.height > pageHeight) {
          //滚动高度变小
          if (Math.abs(lastscrollTop) > Math.abs(layoutRect.top)) {
            translate = 0;
          } else {
            translate = pageHeight - sideRec.height;
          }
          this.scrollTop = layoutRect.top;
        } else {
          //当
          translate = 0;
        }
        this.translate = translate;
      }
    },
    handelResize() {
      this.updateSideBar();
      this.judgeIsMobile();
    }
  }
};
</script>
<style lang="less" scoped>
.layout {
  background-image: url("@/assets/page_bg.webp");
  background-size: cover;
  background-position: 0px -5px;
}

.layout_body {
  width: 100%;
  min-height: 101vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
}

.layout_body_aside {
  width: 2.4rem;
  min-width: 160px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  height: 100vh;
}

.layout_body_aside_panel {
  width: 2.4rem;
  min-width: 160px;
  top: 0;
  left: 0;
  transition: transform 0.2s linear;
  z-index: 200;
  position: absolute;
}

.layout_body_container {
  flex: 1;
}

@media screen and (max-width: 640px) {
  .layout_body_container {
    margin-left: 0 !important;
  }

  .layout_body_container {
    width: 100%;
  }

  .layout_body {
    flex-direction: column;
  }

  .layout_body_aside_molile {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }

  .layout_body_aside_molile_menu {
    height: 100%;
    background-color: #ffffff;
    width: 40vw;
  }
}
</style>